import request from '@/utils/request'

export function getCardTransferLogList(data) {
  return request({
    url: '/api/Extend/LqCardTransferLog',
    method: 'get',
    data
  })
}
